import { reportConstants } from "../constants";
import { history } from "../helpers";
import { reportService } from "../services";
import { alertActions } from "./alertActions";

export const reportActions = {
  getLeadAndSaleOpportunityReport,
  getManagerReport,

};

function getManagerReport(params) {
  return (dispatch) => {
    dispatch(request(reportConstants.GET_MANAGER_REPORT_REQUEST));
    reportService.getManagerReport(params).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(failure(reportConstants.GET_MANAGER_REPORT_FAILURE, "ارتباط با سرور برقرار نیست"));
        } else if (res.success) {
          dispatch(success(reportConstants.GET_MANAGER_REPORT_SUCCESS, res.data));
        } else {
          dispatch(alertActions.error(res.message));
          dispatch(failure(reportConstants.GET_MANAGER_REPORT_FAILURE, res.message));
        }
        setTimeout(() => dispatch(alertActions.clear()), 1500);
      },
      (error) => {
        dispatch(alertActions.error(error.toString()));
        dispatch(failure(reportConstants.GET_MANAGER_REPORT_FAILURE, error.toString()));
      }
    );
  };
}

function getLeadAndSaleOpportunityReport(params) {
  return (dispatch) => {
    dispatch(request(reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_REQUEST));
    reportService.getLeadAndSaleOpportunityReport(params).then(
      (res) => {

        if (res === undefined) {

          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(failure(reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_FAILURE, "ارتباط با سرور برقرار نیست"));

        } else if (res.success) {

          dispatch(success(reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_SUCCESS, res.data));

        } else if (res.success === false) {

          dispatch(alertActions.error(res.message));
          dispatch(success(reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_FAILURE, res.message));

        }

        setTimeout(() => dispatch(alertActions.clear()), 1500);
      },
      (error) => {
        console.log("occurred error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
        dispatch(success(reportConstants.GET_LEAD_AND_SALE_OPPORTUNITY_REPORT_FAILURE, error.toString()));
      }
    );
  };
}

function request(type) {
  return { type: type };
}

function success(type, data) {
  return { type: type, data };
}

function failure(type, error) {
  return { type: type, error };
}
